import ReportCabinet from './ReportCabinet'
export default ReportCabinet